'use client';

import { useContext } from 'react';

import { PageLayoutContext } from '../providers/PageLayoutProvider';

export const usePageLayout = () => {
    const context = useContext(PageLayoutContext);

    if (context === undefined || context === null) {
        throw new Error(
            'usePageLayout must be used within a PageLayoutProvider'
        );
    }

    return {
        flags: {
            legacyDisplay: false,
            ...context.flags,
        },
        ...context,
    };
};
